/* eslint-disable max-len */
var ICON_UI_CIRCLE_ADD = {
  v2: true,
  "default": 'M11.9511 6.47559V17.5245M6.47558 11.9512H17.4267M12 23C18.0751 23 23 18.0751 23 11.9999C23 5.92481 18.0751 1 12 1C5.92487 1 1.00003 5.92481 1.00003 11.9999C1.00003 18.0751 5.92487 23 12 23Z',
  globetrotter: 'M7.5 12H16.5M12 7.5V16.5M22.125 12C22.125 17.595 17.595 22.125 12 22.125C6.405 22.125 1.875 17.595 1.875 12C1.875 6.405 6.405 1.875 12 1.875C17.595 1.875 22.125 6.405 22.125 12Z'
};

export { ICON_UI_CIRCLE_ADD };
//# sourceMappingURL=ICON_UI_CIRCLE_ADD.js.map
